<template>
  <div class="rejoin-container">
    <section-title>
      This game is already in progress, but you can join as one of the people below
    </section-title>
    <div
      class="player-button"
      v-for="player in offlinePlayers"
      :key="player.id"
    >
      <o-button @click="onJoinGame(player.id)" stretch >
        Join Game as "{{ player.name }}"
      </o-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { NS_GAME_STATE } from "@/store/constants";
import OButton from "@/components/OButton";
import SectionTitle from "@/components/SectionTitle";

export default {
  name: 'RejoinGame',

  components: {
    SectionTitle,
    OButton
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'players',
    ]),

    offlinePlayers() {
      return Object.values(this.players).filter(player => {
        return !player.isOnline;
      });
    },
  },

  methods: {
    ...mapActions(NS_GAME_STATE, [
      'rejoinGame',
    ]),

    onJoinGame(playerId) {
      this.rejoinGame(playerId);
    },
  }
}
</script>

<style scoped>
.rejoin-container {
  border: 1px solid #0000001f;
  border-radius: 5px;
}

.player-button {
  padding: 25px;
}
</style>
